import { render, staticRenderFns } from "./TheDailyChallengeOverview.vue?vue&type=template&id=72a92e6e&"
import script from "./TheDailyChallengeOverview.vue?vue&type=script&lang=ts&"
export * from "./TheDailyChallengeOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports